import React, { useEffect, useState } from "react";
import { If } from "react-condition";
import { useHistory, useLocation } from "react-router-dom";
import Loginimg from "../../images/Maxicus_logo.png";
import { LockOutlined, MobileOutlined, MailOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";

import useAxios from "../../hooks/useAxios";
import OtpVerification from "./OTP";

const indianPhoneRegex = /^[6-9]\d{9}$/;
const emailRegex = /^(?!\.)(?!.*\.\.)[^\s@]+(?<!\.)@[^\s@]+\.[^\s@]+$/;

function Login() {
  const locationUrl = useLocation();
  const history = useHistory();
  const api = useAxios();
  const searchParams = new URLSearchParams(locationUrl.search);
  const continueTo = searchParams.get("continueTo");
  const [loginType, setLoginType] = useState("email");
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [password, setPassword] = useState("");
  const [alert, setAlert] = useState("");
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const [isLoginWithOtp, setIsLoginWithOtp] = useState(true);
  const [isOtpSent, setIsOtpSent] = useState(false);

  const handleChange = (e) => {
    let loginType = "email";
    let value = String(e.target.value)?.trim();
    value = value.replace(/[^a-zA-Z0-9.@]/g, "");
    const firstTwoLetter = value?.slice(0, 2);

    if (
      firstTwoLetter &&
      firstTwoLetter.length === 2 &&
      !isNaN(Number(firstTwoLetter))
    ) {
      loginType = "phone";
    }

    if (
      value?.includes("@") ||
      value?.includes(".") ||
      /[a-zA-Z]/.test(value)
    ) {
      loginType = "email";
    }

    setEmailOrPhone(value);
    setLoginType(loginType);
  };

  const checkValidation = () => {
    let e = {};
    const value = emailOrPhone.trim();

    if (!value) {
      e.emailOrPhone = "Email or mobile number is required.";
    }

    if (!password && !isLoginWithOtp) {
      e.password = "Password is required.";
    }

    if (loginType === "phone" && value) {
      if (!indianPhoneRegex.test(value)) {
        e.emailOrPhone = "Enter a valid mobile number.";
      }
    }

    if (loginType === "email" && value) {
      if (!emailRegex.test(value)) {
        e.emailOrPhone = "Enter a valid email address.";
      }
    }

    setError(e);

    return Object.keys(e).length === 0;
  };

  async function onClickLoginWithOtp(event) {
    event.preventDefault();
    setAlert("");
    setError({});
    try {
      const isProceed = checkValidation();

      if (!isProceed) return;

      setLoading(true);
      const result = await api.post(`/candidate/OTPRequest`, {
        ...(loginType === "email"
          ? { email: emailOrPhone }
          : { phone: emailOrPhone }),
      });

      if (result.status === 200) {
        setIsOtpSent(true);
      }
    } catch (error) {
      console.error(error);
      setAlert(
        error.response?.data?.message || "An error occurred. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  }

  async function onClickLogin(event) {
    event.preventDefault();
    setAlert("");
    setError({});
    try {
      const isProceed = checkValidation();

      if (!isProceed) return;

      setLoading(true);
      const { data } = await api.post(`/candidate/login`, {
        ...(loginType === "email"
          ? { email: emailOrPhone }
          : { phone: emailOrPhone }),
        password: password,
      });

      localStorage.clear();
      localStorage.setItem("candidate.token", data.token);
      localStorage.setItem("candidate.name", data.user.name);
      localStorage.setItem("candidate.email", data.user.email);
      localStorage.setItem("candidate.id", data.user._id);
      localStorage.setItem("candidate.role", data.user.role);

      if (continueTo) {
        return history.push(continueTo);
      }

      history.push("/careers/home");
    } catch (error) {
      if (error.message === "Request failed with status code 400") {
        setAlert("Incorrect email or password.");
      } else {
        setAlert(error.message);
      }
    } finally {
      setLoading(false);
    }
  }

  async function onClickVerifyOtp(otp) {
    setAlert("");
    try {
      if (!otp || otp.length !== 6) {
        setAlert("Please enter a valid 6-digit OTP.");
        return;
      }

      setLoading(true);
      const result = await api.post(`/candidate/verifyOTP`, {
        ...(loginType === "email"
          ? { email: emailOrPhone }
          : { phone: emailOrPhone }),
        OTP: otp,
      });

      if (result.status === 200) {
        const data = result.data;
        localStorage.clear();
        localStorage.setItem("candidate.token", data.token);
        localStorage.setItem("candidate.name", data.user.name);
        localStorage.setItem("candidate.email", data.user.email);
        localStorage.setItem("candidate.id", data.user._id);
        localStorage.setItem("candidate.role", data.user.role);

        if (continueTo) {
          return history.push(continueTo);
        }

        history.push("/careers/home");
      }
    } catch (error) {
      console.error(error);
      setAlert(
        error.response?.data?.message || "An error occurred. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  }

  const ForgetPassword = () => {
    history.push("/resetpassword");
  };

  const clearErrors = () => {
    setError({});
    setAlert("");
  };

  const inputStyles = {
    padding: "10px 11px",
    fontSize: "16px",
    lineHeight: 1.5,
    borderRadius: "8px",
  };

  const btnStyle = {
    height: 48,
    borderRadius: 10,
    fontWeight: 500,
    fontSize: 16,
    background:
      "linear-gradient(41deg, rgb(241,120,35) 0%, rgb(248,166,27) 100%)",
    border: "none",
  };

  const IS_EMAIL = loginType === "email";

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-10 col-lg-12 col-md-9">
          <div className="card o-hidden border-0 shadow-lg my-5">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-lg-6 d-none d-lg-block bg-login-image"></div>
                <div className="col-lg-6">
                  <div className="px-4 py-10 flex flex-col items-center h-full">
                    <div className="text-center">
                      <img src={Loginimg} alt="Login" className="mb-1" />
                      <small className="app-name mb-2">Digital Hiring</small>
                      <hr />
                      <h1 className="h4 text-gray-900 mb-4">
                        Candidate Login!
                      </h1>
                    </div>
                    {!isOtpSent ? (
                      <div className="w-full">
                        <If test={alert !== ""}>
                          <div className="alert alert-danger">{alert}</div>
                        </If>
                        <form className="user">
                          <div className="mb-[24px]">
                            <Input
                              type="text"
                              onChange={handleChange}
                              value={emailOrPhone}
                              style={inputStyles}
                              name="email"
                              allowClear
                              prefix={
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6,
                                  }}
                                >
                                  <span className="pr-1">
                                    {IS_EMAIL ? (
                                      <MailOutlined />
                                    ) : (
                                      <MobileOutlined />
                                    )}
                                  </span>
                                  {!IS_EMAIL && (
                                    <span
                                      style={{ fontSize: 16, color: "#555" }}
                                    >
                                      +91
                                    </span>
                                  )}
                                </span>
                              }
                              size="large"
                              placeholder={"Email or mobile number"}
                              status={
                                error?.emailOrPhone && error?.emailOrPhone
                                  ? "error"
                                  : ""
                              }
                            />
                            {error?.emailOrPhone && (
                              <div className="text-[#ff4d4f]">
                                {error?.emailOrPhone}
                              </div>
                            )}
                          </div>
                          {!isLoginWithOtp ? (
                            <>
                              <div className="mb-[24px]">
                                <Input.Password
                                  style={inputStyles}
                                  name="password"
                                  onChange={(e) => setPassword(e.target.value)}
                                  value={password}
                                  size="large"
                                  prefix={
                                    <span className="pr-1">
                                      <LockOutlined />
                                    </span>
                                  }
                                  placeholder={"Enter Password"}
                                  status={
                                    error?.password && error?.password
                                      ? "error"
                                      : ""
                                  }
                                />
                                {error?.password && (
                                  <div className="text-[#ff4d4f]">
                                    {error?.password}
                                  </div>
                                )}
                              </div>
                              <div
                                style={{
                                  marginBlockEnd: 24,
                                }}
                              >
                                <a
                                  onClick={ForgetPassword}
                                  className="underline underline-offset-4"
                                  style={{
                                    float: "right",
                                    textDecoration: "underline",
                                    textDecorationOffset: 3,
                                    color: "darkblue",
                                    fontWeight: 400,
                                  }}
                                >
                                  Forgot Password ?
                                </a>
                              </div>
                              <div>
                                <Button
                                  htmlType="submit"
                                  loading={loading}
                                  onClick={onClickLogin}
                                  className="w-100 mt-4"
                                  type="primary"
                                  value="large"
                                  iconPlacement="end"
                                  style={btnStyle}
                                >
                                  Login
                                </Button>
                              </div>
                              <div className="flex justify-center mt-4">
                                <button
                                  disabled={loading}
                                  onClick={() => {
                                    setIsLoginWithOtp(true);
                                    clearErrors();
                                    setEmailOrPhone("");
                                  }}
                                  className="underline underline-offset-4"
                                  style={{
                                    textDecoration: "underline",
                                    textDecorationOffset: 3,
                                    color: "darkblue",
                                    fontWeight: 400,
                                  }}
                                >
                                  Login with OTP
                                </button>
                              </div>
                            </>
                          ) : (
                            <>
                              <div>
                                <Button
                                  htmlType="submit"
                                  loading={loading}
                                  onClick={onClickLoginWithOtp}
                                  className="w-100"
                                  type="primary"
                                  value="large"
                                  iconPlacement="end"
                                  style={btnStyle}
                                >
                                  Send OTP
                                </Button>
                              </div>
                              <div className="flex justify-center mt-4">
                                <button
                                  disabled={loading}
                                  onClick={() => {
                                    setIsLoginWithOtp(false);
                                    clearErrors();
                                    setEmailOrPhone("");
                                  }}
                                  className="underline underline-offset-4"
                                  style={{
                                    textDecoration: "underline",
                                    textDecorationOffset: 3,
                                    color: "darkblue",
                                    fontWeight: 400,
                                  }}
                                >
                                  Login with password
                                </button>
                              </div>
                            </>
                          )}
                        </form>
                      </div>
                    ) : (
                      <OtpVerification
                        setAlert={setAlert}
                        emailOrPhone={emailOrPhone}
                        setIsOtpSent={setIsOtpSent}
                        alert={alert}
                        type={loginType}
                        handleVerify={onClickVerifyOtp}
                        reSendOtp={onClickLoginWithOtp}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
